import {Client} from "@stomp/stompjs";

const state = {
    client: null,
    connected: false,
    subscriptions: {},
    brokerUrl: "ws://localhost:8080/api/ws",
    debug: true,
};

const getters = {
    isConnected: (state) => state.connected,
};

const mutations = {
    setConnected(state, status) {
        state.connected = status;
    },
    setClient(state, client) {
        state.client = client;
    },
    addSubscription(state, {path, subscription}) {
        state.subscriptions[path] = subscription;
    },
    removeSubscription(state, path) {
        delete state.subscriptions[path];
    },
    reset(state) {
        state.client = null;
        state.connected = false;
        state.subscriptions = {};
    },
};

const actions = {
    connectToServer({commit, state}, options = {}) {
        const {
            brokerUrl = state.brokerUrl, onConnect = () => {
            }, onDebug = null, debug = true
        } = options;
        const client = new Client({
            brokerURL: brokerUrl,
            reconnectDelay: 5000,
            debug: (str) => {
                if (debug && onDebug) {
                    onDebug(str);
                } else if (debug || state.debug) {
                    console.log("[WS]", str);
                }
            },
            onConnect: (frame) => {
                commit("setConnected", true);
                console.log("✅ Connected:", frame.headers["user-name"]);
                onConnect(frame);
            },
            onStompError: (frame) => {
                console.error("❌ Broker error:", frame.headers.message);
            },
        });
        commit("setClient", client);
        client.activate();
    },

    disconnectFromServer({commit, state}) {
        if (state.client && state.connected) {
            Object.values(state.subscriptions).forEach((sub) => sub.unsubscribe());
            state.client.deactivate();
            commit("reset");
            console.log("🔌 Disconnected");
        }
    },

    sendMessage({state}, {destination, body}) {
        if (!state.connected) {
            console.warn("⚠️ Cannot send: not connected");
            return;
        }
        state.client.publish({
            destination,
            body: JSON.stringify(body),
        });
        console.log("📤 Sent to", destination, ":", body);
    },

    subscribeToTopic({state, commit}, {path, callback}) {
        console.debug("subscribeToTopic")
        if (!state.connected) {
            console.warn("⚠️ Cannot subscribe: not connected");
            return;
        }
        if (state.subscriptions[path]) {
            console.warn(`⚠️ Already subscribed to ${path}`);
            return;
        }
        const subscription = state.client.subscribe(path, (msg) => {
            console.log(`📥 Received on ${path}:`, msg.body);
            callback(msg.body);
        });
        commit("addSubscription", {path, subscription});
        console.log(`🔔 Subscribed to ${path}`);
    },

    unsubscribeFromTopic({state, commit}, path) {
        if (state.subscriptions[path]) {
            state.subscriptions[path].unsubscribe();
            commit("removeSubscription", path);
            console.log(`🛑 Unsubscribed from ${path}`);
        }
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
};
